import React, { Suspense, useState } from 'react';
import { Box, CircularProgress, Container, CssBaseline, Toolbar } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material';
import { plPL } from '@mui/material/locale';
import { Generator } from './generator/generator.page';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { TopBar } from '../components/topBar';
import { ROUTES } from '../components/consts';
import { HomePage } from './home/home.page';
import { Templates } from './templates/templates.page';
import { CreateTemplate } from './templates/components/createTemplate.component';
import { UpdateTemplate } from './templates/components/updateTemplate.component';
import { Help } from './help/help.page';
import { ManageHelp } from './help/components/manageHelp.component';
import CreateHelp from './help/components/createHelp.component';
import UpdateHelp from './help/components/updateHelp.component';

export const App: React.FC = () => {
  const [darkState, setDarkState] = useState(true);

  const theme = createTheme(
    {
      palette: {
        mode: darkState ? 'dark' : 'light',
      },
      typography: {
        "fontFamily": `"Montserrat", sans-serif`,
      }
    },
    plPL,
  );

  const handleThemeChange = () => {
    setDarkState(!darkState);
  };

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />

        <BrowserRouter>
          <Suspense fallback={(
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <CircularProgress size={70} />
            </Box>
          )}>
            <TopBar darkState={darkState} handleThemeChange={handleThemeChange} />
            <Box
              component="main"
              sx={{
                flexGrow: 1,
                height: '100vh',
                overflow: 'auto',
              }}
            >
              <Toolbar />
              <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
                <Routes>
                  <Route path={ROUTES.generator.href} element={<Generator />} />
                  <Route path={ROUTES.templates.href} element={<Templates />} />
                  <Route path={ROUTES.templateCreate.href} element={<CreateTemplate />} />
                  <Route path={ROUTES.templateUpdate.href} element={<UpdateTemplate />} />
                  <Route path={ROUTES.help.href} element={<Help />} />
                  <Route path={ROUTES.helpManage.href} element={<ManageHelp />} />
                  <Route path={ROUTES.helpCreate.href} element={<CreateHelp />} />
                  <Route path={ROUTES.helpUpdate.href} element={<UpdateHelp />} />
                  <Route path={ROUTES.app.href} element={<HomePage />} />
                </Routes>
              </Container>
            </Box>
            </Suspense>
        </BrowserRouter>
      </Box>
    </ThemeProvider>
  );
};
